/* eslint-disable node/no-process-env */

export const sentryScriptSource =
  process.env.NEXT_PUBLIC_SENTRY_SCRIPT_SOURCE ||
  "https://js.sentry-cdn.com/c1eee77119d5406999205fc60812bf63.min.js";
